import axios from "axios"
/**
 * axiosの基本設定
 */
export default axios.create({
  baseURL: import.meta.env.VITE_API_URL,
  headers: {
    "Content-Type": "application/json",
    "x-api-key": import.meta.env.VITE_API_KEY,
    Authorization: "Bearer unauthorized"
  }
})
